import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const removeLineItem = (
  repository: CartRepository,
  lineItemId: string
): Promise<Cart> => {
  return repository.removeLineItem(lineItemId);
};

export default removeLineItem;
